var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusha(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10236_2587)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10236_2587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0818 13.0854C19.0818 10.6103 17.3275 8.54481 14.9945 8.06481C14.9859 8.08989 14.9774 8.11513 14.9687 8.14019V8.14031C13.8891 11.2295 12.2082 14.0383 10.0667 16.4235C11.0067 17.5178 12.4005 18.211 13.9562 18.211C16.787 18.211 19.0818 15.9162 19.0818 13.0854ZM9.61862 1.86803C9.09727 6.95049 6.44141 11.4171 2.56707 14.3413L6.71692 17.2352C7.09238 16.9108 7.45685 16.5734 7.80956 16.2241C7.32778 15.2825 7.05604 14.2157 7.05604 13.0854C7.05604 9.35264 10.02 6.31223 13.7228 6.18916C14.0701 4.9504 14.3155 3.67086 14.4477 2.35581L9.61862 1.86803ZM8.83043 13.0854C8.83045 13.6884 8.93486 14.2669 9.12612 14.8043C10.826 12.812 12.1873 10.5226 13.1221 8.02742C10.688 8.42578 8.83043 10.5385 8.83043 13.0854ZM20.8563 13.0854C20.8561 16.8961 17.767 19.9854 13.9562 19.9854C11.9227 19.9854 10.0946 19.1057 8.8318 17.7062C8.34908 18.1716 7.84643 18.6173 7.32525 19.0403C7.01814 19.2895 6.58311 19.3052 6.2587 19.079L0.510604 15.0704C0.268179 14.9014 0.125823 14.6227 0.130996 14.3272C0.136179 14.0317 0.288166 13.7581 0.536349 13.5977C4.7735 10.8581 7.64892 6.1833 7.91762 0.849387L7.92096 0.804087C7.94394 0.578558 8.05263 0.369745 8.22543 0.221244C8.40977 0.0628374 8.65101 -0.0130973 8.89281 0.0113267L15.4918 0.677839C15.9662 0.725752 16.3179 1.14006 16.2882 1.61591C16.1861 3.24916 15.9223 4.83436 15.5152 6.36207C18.5751 7.06879 20.8563 9.81072 20.8563 13.0854Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10236_2587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 20,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10236_2587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.7461,
    height: 20,
    fill: "currentColor",
    transform: "translate(0.126953)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusha);
export default __webpack_public_path__ + "static/media/busha.ae314376a074b83706c99b892095ec23.svg";
export { ForwardRef as ReactComponent };